/**
 * "Minhas integrações de IA" (ADR-0091). Backend: app `conexoes_ia`.
 *
 *   GET    /api/conexoes-ia/minhas                     -> endereço do MCP, chaves, conexões, atividade
 *   POST   /api/conexoes-ia/chaves                     -> { chave, valor }  (valor só aqui, uma vez)
 *   DELETE /api/conexoes-ia/chaves/<id>
 *   POST   /api/conexoes-ia/conexoes/desconectar       -> { cliente_id, recurso }
 *   GET    /api/conexoes-ia/atividade?inicio=&quantos=  -> { itens, tem_mais } ("Mostrar mais")
 *   POST   /api/conexoes-ia/atividade/<id>/desfazer
 */

const BASE = "/api/conexoes-ia";
const post = (corpo) => ({ method: "POST", body: JSON.stringify(corpo || {}) });

export const lerMinhasIntegracoes = (request) => request(`${BASE}/minhas`, { silentError: true });
export const criarChave = (request, { nome, escopos, dias }) => request(`${BASE}/chaves`, post({ nome, escopos, dias }));
export const revogarChave = (request, id) => request(`${BASE}/chaves/${id}`, { method: "DELETE" });
export const desconectarAplicativo = (request, { cliente_id, recurso }) => request(`${BASE}/conexoes/desconectar`, post({ cliente_id, recurso }));
export const lerAtividadeDaIa = (request, { inicio, quantos }) =>
  request(`${BASE}/atividade?${new URLSearchParams({ inicio: String(inicio), quantos: String(quantos) })}`);
export const desfazerAcaoDaIa = (request, id) => request(`${BASE}/atividade/${id}/desfazer`, post());
